module.exports = __webpack_public_path__ + "img/collection-cover page.7b8febd6.png";